import React from 'react';

function ChamadoDescription({ children, className }) {
    return (
        <div className={`chamado-description-card${className ? ` ${className}` : ''}`}>
            {children}
        </div>
    );
}

export default ChamadoDescription;
